import React, { useState } from 'react';
import classNames from 'classnames';
import { stub as $t } from '@nbcnews/analytics-framework';
import { SocialShareMenu } from 'components/Social/SocialShareMenu';
import * as CustomPropTypes from 'lib/CustomPropTypes';

import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const EVENT_NAME = 'mbt_video_socialShare';

$t('register', EVENT_NAME);

/**
 *
 * @param {object} props - The properties for the component.
 * @param {object} props.content - The content object containing details to be displayed.
 * @param {object} props.propStyles - CSS classes for extra specificity to override default styles in some components.
 */
export const SocialShareInline = ({ content, propStyles }) => {
  const [shareExpanded, setShareExpanded] = useState(false);
  const {
    headline, urls, url: bentoUrl, shortUrl,
  } = content;
  const url = (urls?.short) || (bentoUrl?.short) || shortUrl;
  const headlineText = (headline?.social) || (headline?.actual) || (headline?.primary) || '';

  return (
    <div
      className={classNames(
        propStyles.share,
        styles.share,
        {
          [propStyles.shareExpanded]: shareExpanded,
          [styles.shareExpanded]: shareExpanded,
        },
        'dn-print',
      )}
      data-testid="social-share-inline"
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={classNames(
          propStyles.shareExpander,
          styles.shareExpander,
          {
            [styles.hoverEffect]: !shareExpanded,
          },
        )}
        onClick={() => setShareExpanded(!shareExpanded)}
      >
        <span className={classNames(styles.shareDot, propStyles.shareDot)} />
        <svg
          className={classNames(styles.shareClose, propStyles.shareClose)}
          viewBox="0 0 15 15"
        >
          <line className={styles.shareLine} x1="0" x2="15" y1="0" y2="15" />
          <line className={styles.shareLine} x1="0" x2="15" y1="15" y2="0" />
        </svg>
      </div>
      <div className={classNames(styles.shareList, propStyles.shareList)}>
        <SocialShareMenu
          url={url}
          headline={headlineText}
          trackingEventName={EVENT_NAME}
          cidEventNamePrefix={EVENT_NAME}
          pageRegion="inline-share"
          tooltipAlign="center"
          addClassName={styles.socialShareMenu}
        />
      </div>
    </div>
  );
};

SocialShareInline.propTypes = {
  content: CustomPropTypes.content.isRequired,
  propStyles: PropTypes.shape({
    share: PropTypes.string,
    shareExpanded: PropTypes.string,
    shareExpander: PropTypes.string,
    shareDot: PropTypes.string,
    shareClose: PropTypes.string,
    shareList: PropTypes.string,
  }),
};
